import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = ['FETCH_COMPANY_TAXATION_DETAILS'] as const

export default serviceActionsGenerator('taxation-details', actionTypes)
